import 'core-js/stable';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueMask from 'di-vue-mask';
import App from './App.vue';
import { router } from './router';
import { store } from './store';
import VueTabs from 'vue-nav-tabs';
import Vue2Filters from 'vue2-filters';
import VueSocketIO from 'vue-socket.io';
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';

window.Vue = Vue;

// Configurar Vue DevTools para Vue 2 (suprimir avisos)
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = false;

// Variável privada para armazenar o valor de URL sem causar recursão
let _apiUrlValue = '';

// Flag para indicar se window.URL já foi inicializado como string (não getter)
let _urlWasString = false;

// Helper para obter a URL da API de forma segura (sem recursão)
function getApiURL() {
    // Primeiro verifica API_URL (prioridade)
    if (window.API_URL && typeof window.API_URL === 'string') {
        _apiUrlValue = window.API_URL; // Atualiza o valor interno
        return window.API_URL;
    }
    // Se window.URL já era uma string antes de definirmos o getter, usa o valor armazenado
    if (_urlWasString) {
        return _apiUrlValue;
    }
    // Retorna o valor armazenado internamente
    return _apiUrlValue;
}

// Verificar se window.URL já é uma string (compatibilidade com código antigo)
if (typeof window.URL === 'string') {
    _apiUrlValue = window.URL;
    _urlWasString = true;
} else {
    // Se window.URL não é string, provavelmente é o construtor nativo
    // Preserva o construtor nativo URL em outra propriedade se necessário
    if (window.URL && typeof window.URL === 'function') {
        window.URLConstructor = window.URL; // Preserva o construtor original
    }
    
    // Define window.URL como getter que retorna a URL da API
    Object.defineProperty(window, 'URL', {
        get: function() {
            // Verifica API_URL primeiro (sem recursão, acesso direto)
            if (window.API_URL && typeof window.API_URL === 'string') {
                _apiUrlValue = window.API_URL;
                return window.API_URL;
            }
            // Retorna o valor armazenado internamente (evita recursão)
            return _apiUrlValue;
        },
        set: function(value) {
            if (typeof value === 'string') {
                _apiUrlValue = value;
                _urlWasString = true;
            }
        },
        configurable: true
    });
    
    // Inicializa o valor se API_URL já estiver definido
    if (window.API_URL && typeof window.API_URL === 'string') {
        _apiUrlValue = window.API_URL;
    }
}

Vue.use(VueTabs);
Vue.use(VueResource);
Vue.use(VueMask);
Vue.use(Vue2Filters);
Vue.use(VueClipboard);

Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    }
});

import Vuikit from 'vuikit';
import VuikitIcons from '@vuikit/icons';
import {Login} from './class/login';

Vue.use(Vuikit);
Vue.use(VuikitIcons);

/*
Vue.use(new VueSocketIO({
    debug: true,
    connection: getApiURL() + ':6000/',
    transports: ['websocket'],
    'forceNew': true
}));
*/

//console.log(window.URL + ':6000');

/*
import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );
*/
Vue.component('menu-superior',() =>
    import (/* webpackChunkName:"components/menu-superior" */ './components/MenuSuperior'));

navigator.permissions.query({ name: 'clipboard-write', allowWithoutGesture: false }).then((permissionStatus) => {
    // Será 'granted', 'denied' or 'prompt':
    console.log(permissionStatus.state);

// Escuta mudanças ao estado de permissão
    permissionStatus.onchange = () => {
        console.log(permissionStatus.state);
    };
});

const apiURL = getApiURL();
Vue.http.options.root = apiURL;
//Vue.axios.options.root = apiURL;
axios.defaults.baseURL = apiURL;

// Vue.http.options.root = 'https://api.rastreamos.app';
// Vue.http.options.root = 'https://api.test.rastreamos.com.br';
// Vue.http.options.root = 'https://api.riotrack.com.br/';
// Vue.http.options.root = 'http://192.168.0.23:2000';
// Vue.http.options.root = 'https://api.rastrearfrota.com.br';
// Vue.http.options.root = 'https://api-demo.traksatsistemas.com.br';
// Vue.http.options.root = "http://144.202.13.234:2000";
// Vue.http.options.root = "https://api.centersat.com.br";
// Vue.http.options.root = "https://api.riotrack.com.br"

Vue.http.headers.common['Authorization'] = 'JWT '+ window.localStorage.getItem('token');
axios.defaults.headers.common['Authorization'] = 'JWT '+ window.localStorage.getItem('token');

const check = () => {
    if (window.localStorage.getItem('token')) {
        Login.check().catch((err) => {
            console.log(err.status);
            if (err.status === 401) {
                window.localStorage.clear();
                router.push('/login');
            }
        });
    }
};

// setInterval(() => check(), 60000);

/*
setTimeout(() => check(), 1000);
*/

new Vue({
    el: '#app',
    router,
    sockets: {
        connect() {
            console.log('socket connected');
        },
    },
    store,
    render: h => h(App)
});
